import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 13c-1.1 0-2.042-.392-2.825-1.175C8.392 11.042 8 10.1 8 9V5.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 9.5 4c.25 0 .488.058.713.175.225.117.404.283.537.5a1.35 1.35 0 0 1 .537-.5C11.512 4.058 11.75 4 12 4c.25 0 .488.058.713.175.225.117.404.283.537.5a1.35 1.35 0 0 1 .537-.5c.225-.117.463-.175.713-.175.417 0 .77.146 1.063.438.291.291.437.645.437 1.062V9c0 1.1-.392 2.042-1.175 2.825C14.042 12.608 13.1 13 12 13Zm-8 8v-2.8c0-.567.146-1.087.438-1.563A2.918 2.918 0 0 1 5.6 15.55a14.843 14.843 0 0 1 3.15-1.163A13.76 13.76 0 0 1 12 14c1.1 0 2.183.13 3.25.387 1.067.259 2.117.646 3.15 1.163.483.25.87.613 1.163 1.087.291.476.437.996.437 1.563V21H4Z" }, null, -1)
  ])))
}
export default { render: render }